var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5462_17940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8749 0.0499997C12.4499 0.140625 12.3312 0.228125 11.553 0.996875L10.8374 1.70625L12.5687 3.43125L14.2968 5.15625L14.9718 4.48125C15.6968 3.75625 15.8249 3.5875 15.9405 3.20938C15.9968 3.03437 16.003 2.94062 15.9937 2.64687C15.9687 2.00312 15.8624 1.82187 14.9874 0.953125C14.2968 0.265625 14.1687 0.175 13.7312 0.0625C13.453 -0.0093751 13.1655 -0.0125003 12.8749 0.0499997Z",
    fill: "#598BEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42812 7.11875L0.99375 11.5531L0.496875 13.5344C0.209375 14.6906 0 15.5781 0 15.6656C0 15.8813 0.11875 16 0.334375 16C0.421875 16 1.30938 15.7906 2.46563 15.5031L4.44688 15.0062L8.88125 10.5719C11.3188 8.13438 13.3125 6.12813 13.3125 6.10938C13.3125 6.06875 9.93125 2.6875 9.89062 2.6875C9.87187 2.6875 7.86562 4.68125 5.42812 7.11875Z",
    fill: "#598BEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5462_17940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.bf3cf3b62291ea71dac46c1bc678e63e.svg";
export { ForwardRef as ReactComponent };